//#region DevExtreme Imports

import 'devextreme/ui/form'

//#endregion

import { IMRDataTypePanelController } from "./data-type-panel.controller";
import { GRID_SERVICE_NAME } from '../../../services/grid';
import { REFERENCE_TYPE_SERVICE_NAME } from '../../../services/reference-type';
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session';

export const COMPONENT_NAME: string = 'imrDataTypePanel'

//#region Asset Imports

import './data-type-panel.scss'
import * as TEMPLATE from './data-type-panel.tpl.html'

//#endregion

export class IMRDataTypePanelComponent {

    controller = [GRID_SERVICE_NAME, REFERENCE_TYPE_SERVICE_NAME, USER_SESSION_SERVICE_NAME, IMRDataTypePanelController]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}